import { render } from "./cardimg.html?vue&type=template&id=8cc2c66a&scoped=true&external"
import script from "./cardimg.ts?vue&type=script&lang=js&external"
export * from "./cardimg.ts?vue&type=script&lang=js&external"

import "./cardimg.scss?vue&type=style&index=0&id=8cc2c66a&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cc2c66a"],['__file',"src/components/ui/cardimg/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8cc2c66a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8cc2c66a', __exports__)) {
    api.reload('8cc2c66a', __exports__)
  }
  
  module.hot.accept("./cardimg.html?vue&type=template&id=8cc2c66a&scoped=true&external", () => {
    api.rerender('8cc2c66a', render)
  })

}


export default __exports__